import { createSelector } from "reselect";
import { getRouter as getState } from "modules/root/root-selectors";

export const getCurrentRoute = createSelector(getState, state => state.route);
export const getCurrentRouteName = createSelector(
  getCurrentRoute,
  currentRoute => (currentRoute ? currentRoute.name : null)
);
export const getCurrentRouteParams = createSelector(
  getState,
  state => state.route.params
);



// WEBPACK FOOTER //
// ./src/modules/routing/routing-selectors.js